import { AuthenticatedUser } from '@gettactic/api';

export function isOrganizationAdmin(user?: AuthenticatedUser) {
  return user?.user?.organization_user.roles.includes('owner');
}
